<button
  mat-icon-button
  [matMenuTriggerFor]="menu"
  aria-label="Admin menu"
  [matTooltip]="'ADMINISTRATION' | transloco"
>
  <mat-icon>lock</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="openAdmin()">
    <mat-icon>admin_panel_settings</mat-icon>
    <span transloco="ADMINISTRATION"></span>
  </button>
  <button mat-menu-item (click)="openUserManagement()">
    <mat-icon>groups</mat-icon>
    <span transloco="USER_MENU"></span>
  </button>
  @if (isGlobalActionDesignConfigured) {
    <button
      mat-menu-item
      (click)="openGlobalActionDesign()"
      [matTooltip]="('DATABASE_SELECTION_REQUIRED' | transloco) + '.'"
      [matTooltipDisabled]="isGlobalActionDesignEnabled$ | async"
      [disabled]="(isGlobalActionDesignEnabled$ | async) !== true"
    >
      <mat-icon>account_tree</mat-icon>
      <span transloco="GLOBALACTION_DESIGN_MENU"></span>
    </button>
  }
  <button mat-menu-item (click)="openLicenseManager()">
    <mat-icon>local_activity</mat-icon>
    <span transloco="LICENSE_MANAGER"></span>
  </button>
  @if (showBulkUpdate$ | async) {
    <button mat-menu-item (click)="openBulkUpdater()">
      <mat-icon>find_replace</mat-icon>
      <span transloco="BULK_UPDATE_DOCUMENTS"></span>
    </button>
  }
  @if (showBulkCsvUpdate$ | async) {
    <button mat-menu-item (click)="openBulkCSVUpdater()">
      <mat-icon>find_replace</mat-icon>
      <span transloco="BULK_CSV_UPDATE_DOCUMENTS"></span>
    </button>
  }
</mat-menu>
